import React from "react"

import { PRODUCT_POSITION_TABLE_QUANTITY_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowQuantityCellProps
  extends ProductPositionRowCellProps {
  quantity: number
  isHidden?: boolean
}

export const ProductPositionRowQuantityCell = React.memo(
  React.forwardRef(
    (
      { quantity, isHidden, ...rest }: ProductPositionRowQuantityCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      if (isHidden) {
        return null
      }

      return (
        <ProductPositionTableCell
          ref={ref}
          aria-labelledby={PRODUCT_POSITION_TABLE_QUANTITY_HEADER_ID}
          className="quantity"
          data-testid="quantity-cell"
          {...rest}
        >
          {quantity}
        </ProductPositionTableCell>
      )
    }
  )
)
